import { v4 as uuid } from 'uuid';
import { DxTarget, DxTargetGroup, DxTargetMeasureName } from '@/types/analytics/data-explorer.types';
import { getTargetGroupType } from '@/data-explorer/helpers/common.util';
import { EventName } from '@/types/analytics/analytics.types';

export const createNewTargetGroupObject = (
    targets: DxTarget[] = [],
    measure?: DxTargetMeasureName,
    name?: string,
): DxTargetGroup => {
    const isAppTarget = getTargetGroupType({ targets }) === EventName.App;
    const isProductAreaTarget = getTargetGroupType({ targets }) === EventName.ProductArea;
    const defaultMeasureName = isAppTarget || isProductAreaTarget ? 'numVisitors' : 'total';

    const targetGroup: DxTargetGroup = {
        targets,
        measure: {
            value: {
                name: measure || defaultMeasureName,
            },
            valid: true,
        },
        id: {
            value: uuid(),
            valid: true,
        },
    };
    if (name?.length) {
        targetGroup.name = { value: name, valid: true };
    }

    return targetGroup;
};
